import { ownerService } from '../../services/OwnerService'
import Loading from 'vue-loading-overlay';

export default {
    name: 'Owner',
    components: {
        Loading
    },
    props: {
        caption: {
            type: String,
            default: 'Proprietari'
        },

    },
    data: () => {
        return {
            loading: true,
            currentPage: 1,
            perPage: 10,
            formTitle: '',
            owners: [],
            focusedRowObject: null,
            selectedRowClass: 'secondary',
            fields: [],
            searchFilter: '',
            itemToBeDeleted: null,
        }
    },
    // Fetches posts when the component is created.
    created() {
        var model = this;
        model.fields = [
            { key: 'Id', label: 'Id', thStyle: 'width:10%' },
            { key: 'Description', label: 'Descriere', sortable: true, thStyle: 'width:50%' },
            { key: 'CategoryType', label: 'Tip', sortable: true, thStyle: 'width:40%' }
        ];

        var ownersPromise = ownerService.getOwnerList()
            .then(response => {
                model.owners = response.data;
            })
            .catch(e => {
                showErrorNotification(e);
            });

        axios.all([ownersPromise])
            .then(axios.spread(function () {
                model.loading = false;
            }));
    },
    methods: {
        searchChanged: function (data) {

        },
        addButtonClick() {
            this.$router.push({ path: '/owner/0' })
        },
        editButtonClick(data) {
            if (data != null) {
                var redirectPath = './owner/' + data.item.Id;
                this.$router.push({ path: redirectPath });
            }
        },
        setItemToBeDeleted(data) {
            if (data != null) {
                this.itemToBeDeleted = data.item;
            }
        },
        deleteButtonClick(dataItem) {
            if (dataItem != null) {
                var model = this;

                var ownerPromise = ownerService.deleteOwner(dataItem.Id)
                    .then(response => {
                        model.removeItem(model.owners, dataItem.Id);
                    })

                axios.all([ownerPromise])
                    .then(axios.spread(function () {
                        model.loading = false;
                    }));
            }
        }
    }
}
